import { render, staticRenderFns } from "./ReactionMenu.vue?vue&type=template&id=346a002b&scoped=true&"
import script from "./ReactionMenu.vue?vue&type=script&lang=js&"
export * from "./ReactionMenu.vue?vue&type=script&lang=js&"
import style0 from "./ReactionMenu.vue?vue&type=style&index=0&id=346a002b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346a002b",
  null
  
)

/* custom blocks */
import block0 from "./ReactionMenu.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports